import React, { Component } from 'react'
import Loading from './Loading'
import PropTypes from 'prop-types'
import InputRow from './InputRow'
export default class EducationHistoryUndergraduate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error: '',
      undergradDegree: [],
      highSchoolCertificateData: [],
      highSchoolCertificate: '',
      educationGradeData: [],
      educationGrade: '',
      grade: '',
      endDate: '',
      highSchoolNameData: [],
      highSchoolName: '',
      perviousUniversity: '',
      selectedCountry: '',
      selectedCity:'',
      cityData:[],
      cityDataTransfer:[],
      countryData: this.props.countryData,
      institutionName: '',
      perviousUniversityName: '',
      previousUniversityData: [],
      previousUniversityCountry: '',
      previousUniversityCity: '',
      marks: '',
      isTransfer: false,
      isFoundation:false
    }
    this.addUnderGradDegree = this.addUnderGradDegree.bind(this)
    this.changeHighSchoolCerti = this.changeHighSchoolCerti.bind(this)
    this.getSchoolGrades = this.getSchoolGrades.bind(this)
    this.fetchCity = this.fetchCity.bind(this)
    this.fetchCityForTransfer = this.fetchCityForTransfer.bind(this)
    this.applyFoundationRule=this.applyFoundationRule.bind(this)
    this.changeHighSchoolCertiOnComponenDidMount=this.changeHighSchoolCertiOnComponenDidMount.bind(this)
  }

  componentDidMount() {
    if(this.props.educationHistory.length>0){
    this.fetchCity(parseInt(this.props.educationHistory[0].CountryId) || '')
    this.fetchCityForTransfer(parseInt(this.props.educationHistory[0].TransferCountryId) || '')
  }
    fetch(`${process.env.REACT_APP_API_URL}/api/EducationHistory/GetSchoolCurriculum`)
      .then(res => res.json())
      .then(res => {
        this.setState({ highSchoolCertificateData: res, highSchoolCertificate: '' })
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}/api/EducationHistory/GetSchoolName`))
      .then(res => res.json())
      .then(res => {
        if (res.length) {
          this.setState({ highSchoolNameData: res, highSchoolName: '' })
        }
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}/api/EducationHistory/GetUniversitiesName`))
      .then(res => res.json())
      .then(res => {
        this.setState({ previousUniversityData: res, perviousUniversityName: '' })
      })
      .then(() => this.changeHighSchoolCerti(this.state.highSchoolCertificate))
      .then(() => {
        console.log(this.props)
        if (this.props.educationHistory.length > 1) {
          const underGradDegree = []
          this.props.educationHistory.forEach((element, index) => {
            let highSchoolName
            let perviousUniversity
            if (element.InstitutionId === '8') {
              highSchoolName = [{ Id: '8', value: element.InstitutionName }]
            } else {
              highSchoolName = this.state.highSchoolNameData.filter(ele => ele.Id === parseInt(element.InstitutionId))
            }
            if (element.TranferedInstitutionId === 'other') {
              perviousUniversity = [{ Id: 'other', value: element.TranferedInstitutionName }]
            } else {
              perviousUniversity = this.state.previousUniversityData.filter(ele => ele.Id === parseInt(element.TranferedInstitutionId))
            }
            let yearOfGraduation = ''
            if (element.EndDate) {
              const date = new Date(element.EndDate)
              let month = date.getMonth() + 1
              let day = date.getDate()
              let year = date.getFullYear()
              if (month < 10) {
                month = '0' + month
              }
              if (day < 10) {
                day = '0' + day
              }
              if (year < 10) {
                year = '000' + year
              } else if (year < 100) {
                year = '00' + year
              } else if (year < 1000) {
                year = '0' + year
              }
              yearOfGraduation = year + '-' + month + '-' + day
            }
            
            if (index <= this.props.educationHistory.length - 2) {
              underGradDegree.push({
                highSchoolCertificate: element.CurriculumId,
                endDate: yearOfGraduation || '',
                highSchoolName: highSchoolName && highSchoolName.length > 0 ? highSchoolName[0].Id : '',
                selectedCountry: element.CountryId,
                selectedCity:element.CityId,
                grade: element.GradeId,
                perviousUniversity: perviousUniversity.length ? perviousUniversity[0].Id : '',
                institutionName: highSchoolName && highSchoolName.length > 0 ? highSchoolName[0].value : '',
                perviousUniversityName: perviousUniversity && perviousUniversity.length > 0 ? perviousUniversity[0].value : '',
                previousUniversityCountry: element.TransferCountryId,
                previousUniversityCity: element.TransferCityId,
                mark: element.TotalMark,
                educationGrade : element.EducationGrade
                
              })
            } else {
              this.setState({
                highSchoolCertificate: element.CurriculumId,
                endDate: yearOfGraduation || '',
                highSchoolName: highSchoolName && highSchoolName.length > 0 ? highSchoolName[0].Id : '',
                selectedCountry: element.CountryId,
                selectedCity:element.CityId,
                grade: element.GradeId,
                perviousUniversity: perviousUniversity.length ? perviousUniversity[0].Id : '',
                institutionName: highSchoolName && highSchoolName.length > 0 ? highSchoolName[0].value : '',
                perviousUniversityName: perviousUniversity && perviousUniversity.length > 0 ? perviousUniversity[0].value : '',
                previousUniversityCountry: element.TransferCountryId,
                previousUniversityCity: element.TransferCityId,
                mark: element.TotalMark,
                educationGrade : element.EducationGrade
              })
              this.changeHighSchoolCerti(element.CurriculumId)
              
            }
          })
          this.setState({ undergradDegree: underGradDegree, loading: false })
        } else if (this.props.educationHistory.length === 1) {
          const element = this.props.educationHistory[0]
          let yearOfGraduation = ''
          if (element.EndDate) {
            const date = new Date(element.EndDate)
            let month = date.getMonth() + 1
            let day = date.getDate()
            let year = date.getFullYear()
            if (month < 10) {
              month = '0' + month
            }
            if (day < 10) {
              day = '0' + day
            }
            if (year < 10) {
              year = '000' + year
            } else if (year < 100) {
              year = '00' + year
            } else if (year < 1000) {
              year = '0' + year
            }
            yearOfGraduation = year + '-' + month + '-' + day
          }
          let highSchoolName
          let perviousUniversity
          if (element.InstitutionId === '8') {
            highSchoolName = [{ Id: '8', value: element.InstitutionName }]
          } else {
            highSchoolName = this.state.highSchoolNameData.filter(ele => ele.Id === parseInt(element.InstitutionId))
          }
          if (element.TranferedInstitutionId === 'other') {
            perviousUniversity = [{ Id: 'other', value: element.TranferedInstitutionName }]
          } else {
            perviousUniversity = this.state.previousUniversityData.filter(ele => ele.Id === parseInt(element.TranferedInstitutionId))
          }

          this.setState({
            highSchoolCertificate: element.CurriculumId,
            endDate: yearOfGraduation || '',
            highSchoolName: highSchoolName && highSchoolName.length > 0 ? highSchoolName[0].Id : '',
            selectedCountry: element.CountryId,
            selectedCity:element.CityId,
            grade: element.GradeId,
            perviousUniversity: perviousUniversity.length ? perviousUniversity[0].Id : '',
            loading: false,
            institutionName: highSchoolName && highSchoolName.length > 0 ? highSchoolName[0].value : '',
            perviousUniversityName: perviousUniversity && perviousUniversity.length > 0 ? perviousUniversity[0].value : '',
            previousUniversityCountry: element.TransferCountryId,
            previousUniversityCity: element.TransferCityId,
            mark: element.TotalMark,
            educationGrade : element.EducationGrade,
            isTransfer:perviousUniversity.length>0? true:false,
          })
          this.changeHighSchoolCerti(element.CurriculumId)
          this.changeHighSchoolCertiOnComponenDidMount(element.CurriculumId,perviousUniversity.length>0)
        } else {
          this.setState({ loading: false })
        }
      })
      .catch(err => console.log(err))
      console.log()
  }

   getSchoolGrades (val) {
    var schoolGrade =  fetch(`${process.env.REACT_APP_API_URL}/api/EducationHistory/GetSchoolGrade?curriculumId=${val}`)
      .then(res => res.json())
      .then(res => {
        this.setState({ educationGradeData: res })
        if (res.length) {
          this.setState({ educationGrade: this.props.educationGrade})
          return ''
        }
      })
      .catch(err => console.log(err))
      //this.setState({ educationGrade: this.props.educationGrade})
    return schoolGrade
  }

  async fetchCity (val) {
    var city = await fetch(`${process.env.REACT_APP_API_URL}/api/AddressInformation/GetCitiesByCountry?countryid=${val}`)
      .then(res => res.json())
      .then(res => {
        this.setState({ cityData: res })
        if (res.length) {
          this.setState({ selectedCity: this.props.city || '' })
          return ''
        }
      })
      .catch(err => console.log(err))
      
    return city
  }

  async fetchCityForTransfer (val) {
    var city = await fetch(`${process.env.REACT_APP_API_URL}/api/AddressInformation/GetCitiesByCountry?countryid=${val}`)
      .then(res => res.json())
      .then(res => {
        this.setState({ cityDataTransfer: res })
        if (res.length) {
          this.setState({ previousUniversityCity: this.props.city || '' })
          return ''
        }
      })
      .catch(err => console.log(err))
      
    return city
  }
  removeUnderGradDegree(index) {
    /* This function removes the degree from the visible list, while keeping the values that are in the input boxes intact
     and also updates the state to Mains.js */
    const {
      highSchoolName,
      highSchoolCertificate,
      grade,
      endDate,
      selectedCountry,
      selectedCity,
      perviousUniversity,
      institutionName,
      perviousUniversityName,
      undergradDegree,
      previousUniversityCountry,
      previousUniversityCity,
      mark,
      isFoundation
    } = this.state
    const degrees = []
    undergradDegree.forEach((element, index1) => {
      if (index1 !== index) {
        degrees.push(element)
      }
    })
    this.props.collectState('EH', {
      underGradDegree: degrees,
      highSchoolCertificate: highSchoolCertificate,
      endDate: endDate,
      highSchoolName: highSchoolName,
      selectedCountry: selectedCountry,
      selectedCity:selectedCity,
      grade: grade,
      mark: mark,
      perviousUniversity: perviousUniversity,
      institutionName: institutionName,
      perviousUniversityName: perviousUniversityName,
      previousUniversityCity: previousUniversityCity,
      previousUniversityCountry: previousUniversityCountry,
      isFoundation:isFoundation
    })
    this.setState({ undergradDegree: degrees })
  }

  addUnderGradDegree() {
    /* This function does the following :
      1. Checks if the data is validated or not ( Required fields filled and format is correct )
      2. Adds degree and updates state in Main.js if validated.
      3. Shows an alert of error if not.
          */
    const {
      highSchoolName,
      highSchoolCertificate,
      grade,
      endDate,
      selectedCountry,
      selectedCity,
      perviousUniversity,
      institutionName,
      perviousUniversityName,
      previousUniversityCountry,
      previousUniversityCity,
      mark,
      educationGrade
    } = this.state
    if (highSchoolCertificate !== '' && endDate && highSchoolName !== '' && selectedCountry !== '' && grade && mark) {
      if (highSchoolName === 'other' && !institutionName) {
        alert('Please fill all required fields before adding new!')
      } else if (perviousUniversity === 'other' && !perviousUniversityName) {
        alert('Please fill all required fields before adding new!')
      } else if (perviousUniversity && !previousUniversityCountry && !previousUniversityCity) {
        alert('Please fill all required fields before adding new!')
      } else {
        const degree = {
          highSchoolCertificate: highSchoolCertificate,
          endDate: endDate,
          highSchoolName: highSchoolName,
          selectedCountry: selectedCountry,
          selectedCity:selectedCity,
          grade: grade,
          mark: mark,
          perviousUniversity: perviousUniversity,
          institutionName: institutionName,
          perviousUniversityName: perviousUniversityName,
          previousUniversityCountry: previousUniversityCountry,
          previousUniversityCity: previousUniversityCity,
          educationGrade:educationGrade

        }
        this.props.collectState('EH', {
          underGradDegree: [...this.state.undergradDegree, degree],
          highSchoolCertificate: '',
          endDate: '',
          highSchoolName: '',
          selectedCountry: '',
          selectedCity:'',
          grade: '',
          mark: '',
          perviousUniversity: '',
          institutionName: '',
          perviousUniversityName: '',
          previousUniversityCountry: '',
          previousUniversityCity: '',
          educationGrade:'',
          isFoundation:false
        })
        this.setState({ undergradDegree: [...this.state.undergradDegree, degree] })
        this.setState({
          highSchoolCertificate: '',
          endDate: '',
          highSchoolName: '',
          selectedCountry: '',
          selectedCity:'',
          grade: '',
          mark: '',
          perviousUniversity: '',
          institutionName: '',
          perviousUniversityName: '',
          previousUniversityCountry: '',
          previousUniversityCity: '',
          educationGrade:''
        })
      }
    } else {
      alert('Please fill all required fields before adding new!')
    }
  }

  changeHighSchoolCerti(val) {

    const isTransfer =this.state.isTransfer
    this.setState({ highSchoolCertificate: val })
    this.getSchoolGrades(val)
    if ((val === '27' || val === '52' || val === '44' || val === '53') && isTransfer==false) {
      this.props.changeFoundation(true)
    }else{
      this.props.changeFoundation(false)
    }
  }



  
  changeHighSchoolCertiOnComponenDidMount(val,trans) {


    if ((val === 27 || val === 52 || val === 44 || val === 53) && trans==false) {

      this.props.changeFoundation(true)
    }else{
      this.props.changeFoundation(false)
    }
  }
  applyFoundationRule(val) {
    const highSchoolCertificate =this.state.highSchoolCertificate
    console.log(highSchoolCertificate)
    console.log(val)
    if (( highSchoolCertificate === 27 || highSchoolCertificate === 52 || highSchoolCertificate === 44  || highSchoolCertificate === 53
       || highSchoolCertificate === '27' || highSchoolCertificate === '52' || highSchoolCertificate === '44' || highSchoolCertificate === '53') && val==false) {
      console.log(111111)
      this.props.changeFoundation(true)
    }else{
      console.log(22222)
      this.props.changeFoundation(false)
    }
  }
  renderUnderGraduate() {
    const validationError = this.props.error
    const {
      loading,
      undergradDegree,
      highSchoolNameData,
      highSchoolCertificateData,
      educationGradeData,
      highSchoolName,
      previousUniversityData,
      highSchoolCertificate,
      educationGrade,
      grade,
      endDate,
      selectedCountry,
      selectedCity,
      cityData,
      cityDataTransfer,
      perviousUniversity,
      institutionName,
      perviousUniversityName,
      previousUniversityCountry,
      previousUniversityCity,
      mark,
      isTransfer,
      isFoundation
    } = this.state
    
    if (loading) {
      return <Loading />
    }
    const visibleDetailDegree = []
    if (undergradDegree.length > 0) {
      undergradDegree.forEach((element, index) => {
        let highSchoolName
        if (element.highSchoolName === '8') {
          highSchoolName = [{ Id: '8', value: element.institutionName }]
        } else {
          highSchoolName = highSchoolNameData.filter(ele => ele.Id === parseInt(element.highSchoolName))
        }
        const highSchoolCertiName = highSchoolCertificateData.filter(ele => ele.Id === parseInt(element.highSchoolCertificate))
        visibleDetailDegree.push(
          <div className="degree-wrapper" key={index}>
            <div>
              <p>{highSchoolName.length ? (highSchoolName[0]).value : ''}</p>
              <p>{highSchoolCertiName.length ? highSchoolCertiName[0].value : ''}</p>
            </div>
            <button onClick={this.removeUnderGradDegree.bind(this, index)}>x</button>

          </div>
        )
      })
    }
    if (loading) {
      return <Loading />
    }
    return (
      <div className="education-his-wrapper">
        <div className='education-his-box'>
          <div>
            <InputRow
              name="select"
              rowName="School Name"
              hover="Please insert the name of your High School. أدخل اسم مدرستك الثانوية. "
              required="*"
              errMsg={validationError.highSchoolName ? validationError.highSchoolName : ''}
              //data={highSchoolNameData.length > 0 ? [...highSchoolNameData, { Id: 'other', value: 'Other' }] : highSchoolNameData}
              data={highSchoolNameData}
              value={highSchoolName}
              onChange={(val) => {
                this.setState({ educationGrade:''})
               
                if (val === '8') {
                  this.props.collectState('EH', {
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    educationGrade  :'',
                    grade: grade,
                    mark: mark,
                    endDate: endDate,
                    highSchoolName: val,
                    selectedCountry: selectedCountry,
                    selectedCity:selectedCity,
                    perviousUniversity: perviousUniversity,
                    institutionName: '',
                    perviousUniversityName: perviousUniversityName,
                    previousUniversityCountry: previousUniversityCountry,
                    previousUniversityCity: previousUniversityCity,
                    isFoundation:isFoundation
                  })
                  this.setState({ highSchoolName: val, institutionName: '',selectedCountry:0,selectedCity:0 })
                } else {
                  const hName = highSchoolNameData.filter(ele => parseInt(ele.Id) === parseInt(val))
                  this.props.collectState('EH', {
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    educationGrade:'',
                    grade: grade,
                    mark: mark,
                    endDate: endDate,
                    highSchoolName: val,
                    selectedCountry: '',
                    selectedCity:'',
                    perviousUniversity: perviousUniversity,
                    institutionName: hName && hName.length > 0 ? hName[0].value : '',
                    perviousUniversityName: perviousUniversityName,
                    previousUniversityCountry: previousUniversityCountry,
                    previousUniversityCity: previousUniversityCity,
                    isFoundation:isFoundation
                  })
                  this.setState({ highSchoolName: val, institutionName: hName && hName.length > 0 ? hName[0].value : '' })
                }
              }}
            />
            {highSchoolName === '8'
              ? <InputRow
                name="text"
                rowName="School Name"
                required="*"
                errMsg={validationError.institutionName ? validationError.institutionName : ''}
                value={institutionName}
                onChange={(val) => {
                  this.setState({ institutionName: val, educationGrade:'' })
                  this.props.collectState('EH', {
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    educationGrade:educationGrade,
                    grade: grade,
                    mark: mark,
                    endDate: endDate,
                    highSchoolName: highSchoolName,
                    selectedCountry: selectedCountry,
                    selectedCity:selectedCity,
                    perviousUniversity: perviousUniversity,
                    institutionName: val,
                    perviousUniversityName: perviousUniversityName,
                    previousUniversityCountry: previousUniversityCountry,
                    previousUniversityCity: previousUniversityCity,
                    isFoundation:isFoundation
                  })
                }}
              /> : null}
            {highSchoolName === '8'
              ?<InputRow
              name="select"
              data={this.props.countryData}
              value={selectedCountry}
              required="*"
              errMsg={validationError.selectedCountry ? validationError.selectedCountry : ''}
              rowName="School Country"
              onChange={async (val) => {
                this.setState({ selectedCountry: val , educationGrade:'',selectedCity:''})
                this.props.collectState('EH', {
                  underGradDegree: undergradDegree,
                  highSchoolCertificate: highSchoolCertificate,
                  educationGrade:educationGrade,
                  grade: grade,
                  mark: mark,
                  endDate: endDate,
                  highSchoolName: highSchoolName,
                  selectedCountry: val,
                  selectedCity:selectedCity,
                  perviousUniversity: perviousUniversity,
                  institutionName: institutionName,
                  perviousUniversityName: perviousUniversityName,
                  previousUniversityCountry: previousUniversityCountry,
                  previousUniversityCity: previousUniversityCity,
                  isFoundation:isFoundation
                })
                await this.fetchCity(val)
              }}
            />:null}
           {highSchoolName === '8'
              ? <InputRow
          rowName="City"
          value={selectedCity}
          name="select"
          data={cityData}
          required="*"
          errMsg={validationError.selectedCity ? validationError.selectedCity : ''}
          onChange={(val) => {
            
            this.setState({ selectedCity: val })
            this.props.collectState('EH', {
              underGradDegree: undergradDegree,
              highSchoolCertificate: highSchoolCertificate,
              educationGrade:educationGrade,
              grade: grade,
              mark: mark,
              endDate: endDate,
              highSchoolName: highSchoolName,
              selectedCountry: selectedCountry,
              selectedCity:val,
              perviousUniversity: perviousUniversity,
              institutionName: institutionName,
              perviousUniversityName: perviousUniversityName,
              previousUniversityCountry: previousUniversityCountry,
              previousUniversityCity: previousUniversityCity,
              isFoundation:isFoundation

            })
            //this.fetchRegion(val)
          }}
        /> :null}     
            <InputRow
              name="select"
              rowName="High School Certificate"
              hover="Please select the High School Certificate you have earned . If you cannot find your Certificate, please select Other . يرجى اختيار الشهادة الثانوية التى حصلت عليها."
              required="*"
              errMsg={validationError.highSchoolCertificate ? validationError.highSchoolCertificate : ''}
              data={highSchoolCertificateData}
              value={highSchoolCertificate}
              onChange={(val) => {
                this.changeHighSchoolCerti(val)
                
                this.props.collectState('EH', {
                  underGradDegree: undergradDegree,
                  highSchoolCertificate: val,
                  educationGrade:'',
                  grade: grade,
                  mark: mark,
                  endDate: endDate,
                  highSchoolName: highSchoolName,
                  selectedCountry: selectedCountry,
                  selectedCity:selectedCity,
                  perviousUniversity: perviousUniversity,
                  institutionName: institutionName,
                  perviousUniversityName: perviousUniversityName,
                  previousUniversityCountry: previousUniversityCountry,
                  previousUniversityCity: previousUniversityCity,
                  isFoundation:isFoundation
                })
                
              }}
            />

<InputRow
              name="select"
              rowName="Grade"
              required="*"
              errMsg={validationError.educationGrade ? validationError.educationGrade : ''}
              data={educationGradeData}
              value= {educationGrade}
              onChange={(val) => {
                this.setState({ educationGrade: val })

                this.props.collectState('EH', {
                  underGradDegree: undergradDegree,
                  highSchoolCertificate: highSchoolCertificate,
                  grade: grade,
                  mark: mark,
                  endDate: endDate,
                  highSchoolName: highSchoolName,
                  selectedCountry: selectedCountry,
                  selectedCity:selectedCity,
                  perviousUniversity: perviousUniversity,
                  institutionName: institutionName,
                  perviousUniversityName: perviousUniversityName,
                  previousUniversityCountry: previousUniversityCountry,
                  previousUniversityCity: previousUniversityCity,
                  educationGrade:val,
                  isFoundation:isFoundation
                })
                
              }}
              
            />

            <InputRow
              name="date"
              required="*"
              errMsg={validationError.endDate ? validationError.endDate : ''}
              hover="Please insert the date of your High School Graduation,If you cannot remember the exact day, you can choose the 1st day of the selected month.في أي سنة تخرجت من المدرسة الثانوية ؟إذا كنت لا تستطيع تذكر اليوم بالضبط ضع اليوم الأول من الشهر."
              value={endDate}
              rowName="Graduation date"
              onChange={(val) => {
                const dob = new Date(val)
                if (!isNaN(dob.getFullYear())) {
                  if (parseInt(dob.getFullYear()) <= 9999 )   {
                    this.setState({ endDate: val })
                    this.props.collectState('EH', {
                      underGradDegree: undergradDegree,
                      highSchoolCertificate: highSchoolCertificate,
                      grade: grade,
                      mark: mark,
                      endDate: val,
                      highSchoolName: highSchoolName,
                      selectedCountry: selectedCountry,
                      selectedCity:selectedCity,
                      perviousUniversity: perviousUniversity,
                      institutionName: institutionName,
                      perviousUniversityName: perviousUniversityName,
                      previousUniversityCountry: previousUniversityCountry,
                      previousUniversityCity: previousUniversityCity,
                      educationGrade: educationGrade,
                      isFoundation:isFoundation
                    })
                  }
                } else {
                  this.setState({ endDate: '' })
                  this.props.collectState('EH', {
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    grade: grade,
                    mark: mark,
                    endDate: '',
                    highSchoolName: highSchoolName,
                    selectedCountry: selectedCountry,
                    selectedCity:selectedCity,
                    perviousUniversity: perviousUniversity,
                    institutionName: institutionName,
                    perviousUniversityName: perviousUniversityName,
                    previousUniversityCountry: previousUniversityCountry,
                    previousUniversityCity: previousUniversityCity,
                    educationGrade:educationGrade,
                    isFoundation:isFoundation
                  })
                }
              }}
            />
                   <div className="illness-part">
          <p>Are you a transfer student?</p>
          Yes<input type="radio" value={isTransfer} onChange={() => {
            this.setState({ isTransfer: true })
            this.applyFoundationRule(true)

          }} name="transfer" checked={!!isTransfer} style={{ minWidth: 'auto', marginLeft: 5 }}/>
          No<input type="radio" value={isTransfer} onChange={() => {
            this.setState({ isTransfer: false,perviousUniversity:'',perviousUniversityName:'',previousUniversityCity:'',previousUniversityCountry:'' })
            this.applyFoundationRule(false)
            this.props.collectState('EH', {
              underGradDegree: undergradDegree,
              highSchoolCertificate: highSchoolCertificate,
              grade: grade,
              mark: mark,
              endDate: endDate,
              highSchoolName: highSchoolName,
              selectedCountry: selectedCountry,
              selectedCity:selectedCity,
              perviousUniversity: '',
              institutionName: institutionName,
              perviousUniversityName: '',
              previousUniversityCountry: '',
              previousUniversityCity: '',
              educationGrade: educationGrade,
              isFoundation:isFoundation
            })
          }} name="transfer" checked={!isTransfer} style={{ minWidth: 'auto', marginLeft: 5 }}/>
        </div>
            {isTransfer===true?
            <div>
              <p>If yes, kindly add the country, and city under Previous University</p>
            <InputRow
              name="select"
              rowName="Previous University (Transfer Student)"
              data={previousUniversityData.length > 0 ? [...previousUniversityData, { Id: 'other', value: 'Other' }] : previousUniversityData}
              value={perviousUniversity}
              onChange={(val) => {
                if (val === 'other') {
                  this.setState({ perviousUniversity: val, perviousUniversityName: '' })
                  this.props.collectState('EH', {
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    educationGrade:educationGrade,
                    grade: grade,
                    mark: mark,
                    endDate: endDate,
                    highSchoolName: highSchoolName,
                    selectedCountry: selectedCountry,
                    selectedCity:selectedCity,
                    perviousUniversity: val,
                    institutionName: institutionName,
                    perviousUniversityName: '',
                    previousUniversityCountry: previousUniversityCountry,
                    previousUniversityCity: previousUniversityCity,
                    isFoundation:isFoundation
                  })
                }
                const prevName = val ? previousUniversityData.filter(ele => ele.Id === parseInt(val)) : null
                this.setState({
                  perviousUniversity: val,
                  perviousUniversityName: val && prevName && prevName.length > 0 ? prevName[0].value : '',
                  previousUniversityCountry: '',
                  previousUniversityCity: ''
                })
                this.props.collectState('EH', {
                  underGradDegree: undergradDegree,
                  highSchoolCertificate: highSchoolCertificate,
                  educationGrade:educationGrade,
                  grade: grade,
                  mark: mark,
                  endDate: endDate,
                  highSchoolName: highSchoolName,
                  selectedCountry: selectedCountry,
                  selectedCity:selectedCity,
                  perviousUniversity: val,
                  institutionName: institutionName,
                  perviousUniversityName: val && prevName && prevName.length > 0 ? prevName[0].value : '',
                  previousUniversityCountry: '',
                  previousUniversityCity: '',
                  isFoundation:isFoundation
                })
              }}
            /></div>:null}
            {perviousUniversity === 'other'
              ? <InputRow
                name="text"
                rowName="Previous University Name"
                required="*"
                value={perviousUniversityName}
                errMsg={validationError.perviousUniversityName ? validationError.perviousUniversityName : ''}
                onChange={(val) => {
                  this.setState({ perviousUniversityName: val })
                  this.props.collectState('EH', {
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    educationGrade:educationGrade,
                    grade: grade,
                    mark: mark,
                    endDate: endDate,
                    highSchoolName: highSchoolName,
                    selectedCountry: selectedCountry,
                    selectedCity:selectedCity,
                    perviousUniversity: perviousUniversity,
                    institutionName: institutionName,
                    perviousUniversityName: val,
                    previousUniversityCountry: previousUniversityCountry,
                    previousUniversityCity: previousUniversityCity,
                    isFoundation:isFoundation
                  })
                  
                }}
              /> : null}
            {perviousUniversity === 'other'
              ? <>
                <InputRow
                  name="select"
                  data={this.props.countryData}
                  rowName="Previous University Country"
                  required="*"
                  errMsg={validationError.previousUniversityCountry ? validationError.previousUniversityCountry : ''}
                  onChange={async (val) => {
                    this.setState({ previousUniversityCountry: val ,previousUniversityCity:''})
                    this.props.collectState('EH', {
                      underGradDegree: undergradDegree,
                      highSchoolCertificate: highSchoolCertificate,
                      educationGrade:educationGrade,
                      grade: grade,
                      mark: mark,
                      endDate: endDate,
                      highSchoolName: highSchoolName,
                      selectedCountry: selectedCountry,
                      selectedCity:selectedCity,
                      perviousUniversity: perviousUniversity,
                      institutionName: institutionName,
                      perviousUniversityName: perviousUniversityName,
                      previousUniversityCountry: val,
                      previousUniversityCity: previousUniversityCity,
                      isFoundation:isFoundation
                    })
                    await this.fetchCityForTransfer(val)
                  }}
                  value={previousUniversityCountry}
                />
                <InputRow
                  name="select"
                  data={cityDataTransfer}
                  rowName="Previous University City"
                  required="*"
                  errMsg={validationError.previousUniversityCity ? validationError.previousUniversityCity : ''}
                  onChange={(val) => {
                    this.setState({ previousUniversityCity: val })
                    this.props.collectState('EH', {
                      underGradDegree: undergradDegree,
                      highSchoolCertificate: highSchoolCertificate,
                      educationGrade:educationGrade,
                      grade: grade,
                      mark: mark,
                      endDate: endDate,
                      highSchoolName: highSchoolName,
                      selectedCountry: selectedCountry,
                      selectedCity:selectedCity,
                      perviousUniversity: perviousUniversity,
                      institutionName: institutionName,
                      perviousUniversityName: perviousUniversityName,
                      previousUniversityCountry: previousUniversityCountry,
                      previousUniversityCity: val,
                      isFoundation:isFoundation
                    })
                  }}
                  value={previousUniversityCity}
                />
              </> : null}
          </div>
        </div>

      </div>
    )
  }

  render() {
    const { loading, error } = this.state
    if (loading) {
      return (<Loading />)
    }

    return (
      <div>
        <p style={{ color: 'red' }}>{error}</p>
        {this.renderUnderGraduate()}
        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>
      </div>
    )
  }
}
EducationHistoryUndergraduate.propTypes = {
  countryData: PropTypes.array.isRequired,
  program: PropTypes.number.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  educationHistory: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object,
  changeFoundation: PropTypes.func
}
